import { CommonModule } from '@angular/common';
import { CountdownTimerComponent } from './countdown-timer/countdown-timer.component';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { OpenUntilPipe } from './pipes/open-until.pipe';
import { TimeGapHoursPipe } from './time-gap/time-gap-hours.pipe';
import { TimeGapHumanizePipe } from './time-gap/time-gap-humanize.pipe';
import { FileReaderService } from './file-reader/file-reader.service';
import { MocksService } from './mocks/mocks.service';
import { FileWatcherComponent } from './file-watcher/file-watcher.component';
import { NormalizeLocalISOStringPipe } from './pipes/normalize-timestamp.pipe';
import { ToUntypedIdPipe } from './synced-storage/to-untyped-id.pipe';
import { IsEmptyPipe } from './pipes/is-empty.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    OpenUntilPipe,
    FileWatcherComponent,
    ToUntypedIdPipe,
    IsEmptyPipe
  ],
  declarations: [
    CountdownTimerComponent,
    OpenUntilPipe,
    TimeGapHoursPipe,
    TimeGapHumanizePipe,
    FileWatcherComponent,
    NormalizeLocalISOStringPipe,
    ToUntypedIdPipe,
    IsEmptyPipe
  ],
  providers: [
    TimeGapHoursPipe,
    TimeGapHumanizePipe,
    FileReaderService,
    NormalizeLocalISOStringPipe,
    MocksService,
    ToUntypedIdPipe,
    IsEmptyPipe
  ]
})
export class AppCommonsModule {}
